module.exports = __webpack_public_path__ + "img/odp.01a24afd.svg";